import React from "react";

import { Stack, Typography } from "@mui/material";

import AuthButton from "@app/analytics/auth/components/AuthButton";
import BackToSignUpOptions from "@app/analytics/auth/components/BackToSignUpOptions";
import TermsSection from "@app/analytics/auth/components/TermsSection";
import { Link } from "@app/common/components/Link";
import { SSO_PROVIDERS_BY_ID } from "@app/common/constants/providers";
import type { SSOProviderId } from "@app/common/types/providerTypes";
import * as PolicyUtils from "@app/common/utils/policyUtils";

interface SignupOAuthDetectedContentProps {
  onBack: () => void;
  onClickContinue: (id: SSOProviderId) => void;
  onPreferPassword: () => void;
  providerId: SSOProviderId;
}

const OAuthDetectedContent = ({
  onBack,
  onClickContinue,
  onPreferPassword,
  providerId,
}: SignupOAuthDetectedContentProps) => {
  const provider = SSO_PROVIDERS_BY_ID[providerId];

  return (
    <Stack>
      <Typography variant="bodyPrimaryReg" sx={{ mt: 1, mb: 4 }}>
        The easiest way to sign up is with {provider.displayName}. This will
        automatically connect your calendar so that Read can join your meetings.
      </Typography>
      <AuthButton onClick={() => onClickContinue(providerId)} type="submit">
        Continue with {provider.displayName}
      </AuthButton>
      {!PolicyUtils.newPoliciesReleased() && <TermsSection context="signup" />}
      <Link
        data-test-id="auth-prefer-password"
        variant="labelMed"
        marginY={1}
        onClick={onPreferPassword}
      >
        I prefer to sign up with a password
      </Link>
      <BackToSignUpOptions onClick={onBack} />
    </Stack>
  );
};

export default OAuthDetectedContent;
